<template>
	<div class="ts-space-y-2">
		<fieldset>
			<legend class="text-blue">
				{{ $t('promotion.productLists') }}
				<Tooltip placement="top">
					<Icon type="ios-information-circle-outline" size="17" />
					<div slot="content">
						<div class="ts-text-xs">
							{{ $t('promotion.productLists') }}
						</div>
					</div>
				</Tooltip>
			</legend>
			<div class="ts-space-y-2">
				<div class="row filter">
					<div class="col-md-2">
						<a-select v-model="type" :options="typeLists" class="ts-w-full" style="height: 30px;"
							placeholder="Type" @change="onChangeType"></a-select>
					</div>
					<div class="col-md-4">
						<a-select v-model="pro_group_id" :options="productGroups" show-search allowClear
							option-filter-prop="children" class="ts-w-full" style="height: 30px;"
							placeholder="Filter By Group"></a-select>
					</div>
					<div class="col-md-1"></div>
					<div class="col-md-5">
						<input v-model.trim="search" type="text" :placeholder="$t('search')" class="form-control" />
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 overflow-auto">
						<div class="table-ui-detail" style="min-height: 300px; max-height: 420px">
							<table class="ts-w-full" style="max-height: 420px">
								<thead>
									<tr>
										<th width="5%" class="ts-text-center" v-if="type == 2">
											<a-checkbox v-model="check_all" size="small" @change="onCheckAll"
												:indeterminate="indeterminate" />
										</th>
										<th width="15%">
											{{ $t('promotion.productGroup') }}
										</th>
										<th width="15%">
											{{ $t('promotion.barcode') }}
										</th>
										<th width="25%">
											{{ $t('promotion.product') }}
										</th>
										<th width="10%">
											{{ $t('promotion.discountType') }}
										</th>
										<th width="10%">
											{{ $t('promotion.discountRate') }}
										</th>
										<th width="10%">
											{{ $t('promotion.incentiveType') }}
										</th>
										<th width="10%">
											{{ $t('promotion.incentiveRate') }}
										</th>
										<th width="5%" class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
											<a href="#" v-if="type == 2" class="ts-text-blue-500"
												@click.prevent="addByGroup()">
												<i class="fa fa-plus"></i>
											</a>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="products.length == 0">
										<td colspan="9" class="ts-text-center ts-p-3 ts-space-x-1">
											<i class="fa fa-folder-open ts-text-gray-200"></i>
											<label class="ts-text-gray-400">
												{{ $t('noData') }}
											</label>
										</td>
									</tr>
									<!-- <tr class="ts-cursor-pointer hover:ts-bg-gray-300" v-if="type == 2">
										<td class="ts-text-center">
										</td>
										<td class="ts-px-2">
										</td>
										<td class="ts-px-2">
										</td>
										<td class="ts-px-2">
										</td>
										<td>
											<a-select v-model="group_model.discount_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeGroup()">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(group_model.input_currency_id)">
													{{ getDiscountCurrency(group_model.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>
										<td>
											<input v-if="group_model.discount_type == '%'" ref="discountRate"
												type="number" v-model.number="group_model.input_discount_rate"
												class="form-control" @change="onChangeGroup()" />
											<ts-currency-converter-input v-else
												:input_amount.sync="group_model.input_discount_rate"
												:amount.sync="group_model.discount_rate"
												:input_currency_id.sync="group_model.input_currency_id"
												:currency_id.sync="group_model.currency_id"
												:fx_rate.sync="group_model.fx_rate"
												:fx_rate_ratio.sync="group_model.fx_rate_ratio"
												style="min-width: 120px;" />
										</td>
										<td>
											<a-select v-model="group_model.incentive_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeGroup()">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(group_model.input_currency_id)">
													{{ getDiscountCurrency(group_model.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>
										<td>
											<input v-if="group_model.incentive_type == '%'" ref="incentiveRate"
												type="number" v-model.number="group_model.input_incentive_rate"
												class="form-control" @change="onChangeGroup()" />
											<ts-currency-converter-input v-else
												:input_amount.sync="group_model.input_incentive_rate"
												:amount.sync="group_model.incentive_rate"
												:input_currency_id.sync="group_model.input_currency_id"
												:currency_id.sync="group_model.currency_id"
												:fx_rate.sync="group_model.fx_rate"
												:fx_rate_ratio.sync="group_model.fx_rate_ratio"
												style="min-width: 120px;" />
										</td>
										<td class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
										</td>
									</tr> -->
									<tr v-if="products.length > 0" v-for="(product, index) in products"
										:value="product.product_id" :key="index"
										class="ts-cursor-pointer hover:ts-bg-gray-300">
										<td class="ts-text-center" v-if="type == 2">
											<a-checkbox v-model="product._selected" size="small"
												@change="onCheckItem" />
										</td>
										<td class="ts-px-2">
											{{ product.pro_group_name_en }}
										</td>
										<td class="ts-px-2">
											{{ product.barcode }}
										</td>
										<td class="ts-px-2">
											{{ product.product_name_en }}
										</td>
										<td>
											<a-select v-model="product.discount_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeItem(product)">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(product.input_currency_id)">
													{{ getDiscountCurrency(product.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>
										<td>
											<input v-if="product.discount_type == '%'" ref="discountRate" type="number"
												v-model.number="product.input_discount_rate" class="form-control"
												@change="onChangeItem(product)" />
											<ts-currency-converter-input v-else
												:input_amount.sync="product.input_discount_rate"
												:amount.sync="product.discount_rate"
												:input_currency_id.sync="product.input_currency_id"
												:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
												:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
										</td>
										<td>
											<a-select v-model="product.incentive_type" class="ts-w-full"
												style="min-width: 50px" @change="onChangeItem(product)">
												<a-select-option value="%">%</a-select-option>
												<a-select-option
													:value="getDiscountCurrency(product.input_currency_id)">
													{{ getDiscountCurrency(product.input_currency_id) }}
												</a-select-option>
											</a-select>
										</td>
										<td>
											<input v-if="product.incentive_type == '%'" ref="incentiveRate"
												type="number" v-model.number="product.input_incentive_rate"
												class="form-control" @change="onChangeItem(product)" />
											<ts-currency-converter-input v-else
												:input_amount.sync="product.input_incentive_rate"
												:amount.sync="product.incentive_rate"
												:input_currency_id.sync="product.input_currency_id"
												:currency_id.sync="product.currency_id" :fx_rate.sync="product.fx_rate"
												:fx_rate_ratio.sync="product.fx_rate_ratio" style="min-width: 120px;" />
										</td>
										<td class="ts-px-2 ts-whitespace-no-wrap ts-text-center">
											<a href="#" class="ts-text-blue-500" @click.prevent="addItem(product)">
												<i class="fa fa-plus"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

			</div>
		</fieldset>
	</div>
</template>

<script>
import { includes } from 'lodash';
import { mapState } from 'vuex'
export default {
	name: 'incentiveByAmountProductList',
	props: ['value'],
	data() {
		return {
			search: '',
			type: 1,
			pro_group_id: undefined,
			check_all: false,
			indeterminate: false,
			model: {},
			// group_model: {
			// 	currency_id: 1,
			// 	input_currency_id: 1,
			// 	fx_rate: 1,
			// 	fx_rate_ratio: 1,
			// 	discount_type: '%',
			// 	discount_rate: 0,
			// 	input_discount_rate: 0,
			// 	incentive_type: '%',
			// 	incentive_rate: 0,
			// 	input_incentive_rate: 0,
			// }
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		...mapState('promotion/incentiveByAmount', ['formViewDatas']),
		products() {
			if (this.formViewDatas['products']) {
				return this.formViewDatas['products']
					.filter(p => this.pro_group_id ? p.pro_group_id == this.pro_group_id : true)
					.filter(p => !includes(this.model.condition.map(el => el.product_id), p.product_id))
					.filter(
						p => this.search
							.split(' ')
							.every(s =>
								p.barcode.toLowerCase().includes(s.toLowerCase())
							) ||
							this.search
								.split(' ')
								.every(s => p.product_name_en.toLowerCase().includes(s.toLowerCase()))
					)
					.slice(0, 40)
			}
			return []
		},
		productGroups() {
			if (this.formViewDatas['productGroups']) {
				return this.formViewDatas['productGroups'].map(el => ({
					value: el.pro_group_id,
					label: el.pro_group_name_en + (el.pro_group_name_kh ? '|' + el.pro_group_name_kh : '')
				}))
				// .filter(
				// 	p => this.search
				// 		.split(' ')
				// 		.every(s => p.pro_group_name_en.toLowerCase().includes(s.toLowerCase()))
				// )
			}
			return []
		},
		typeLists() {
			return [
				{
					label: 'By Item',
					value: 1
				},
				{
					label: 'By Group',
					value: 2
				}
			]
		},
	},
	methods: {
		getDiscountCurrency(input_currency_id) {
			if (this.formViewDatas['currency']) {
				return this.formViewDatas['currency'].find(
					el => el.currency_id == input_currency_id
				).currency_symbol
			}
			return null
		},
		onCheckAll(data) {
			this.indeterminate = false
			this.products.forEach(el => {
				el._selected = data.target.checked
			});
		},
		onChangeType(type) {
			if (type == 1) {
				this.products.map(el => el._selected = false)
				this.indeterminate = false
			}
		},
		onCheckItem(data) {
			const is_false = this.products.find(el => el._selected == false)
			const is_true = this.products.find(el => el._selected == true)
			if (is_false && is_true) {
				this.indeterminate = true
			}
			if (!is_false && is_true) {
				this.check_all = true
				this.indeterminate = false
			}
			if (is_false && !is_true) {
				this.check_all = false
				this.indeterminate = false
			}
			if (this.products.length == 0) {
				this.check_all = false
				this.indeterminate = false
			}
		},
		// onChangeGroup() {
		// 	if (this.group_model.discount_type == '%') {
		// 		this.group_model.discount_rate = this.group_model.input_discount_rate
		// 	} else {
		// 		this.group_model.discount_type = this.getDiscountCurrency(this.group_model.input_currency_id)
		// 		this.group_model.discount_rate = this.group_model.input_discount_rate * this.group_model.fx_rate_ratio
		// 	}

		// 	if (this.group_model.incentive_type == '%') {
		// 		this.group_model.incentive_rate = this.group_model.input_incentive_rate
		// 	} else {
		// 		this.group_model.incentive_type = this.getDiscountCurrency(this.group_model.input_currency_id)
		// 		this.group_model.incentive_rate = this.group_model.input_incentive_rate * this.group_model.fx_rate_ratio
		// 	}
		// },
		onChangeItem(product) {
			if (product.discount_type == '%') {
				product.discount_rate = product.input_discount_rate
			} else {
				product.discount_type = this.getDiscountCurrency(product.input_currency_id)
				product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
			}

			if (product.incentive_type == '%') {
				product.incentive_rate = product.input_incentive_rate
			} else {
				product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
				product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
			}
		},
		addByGroup() {
			let products = this.products.filter(el => el._selected == true)

			if (products) {
				products.forEach(product => {
					this.model.condition.push({
						pro_group_id: product.pro_group_id,
						product_id: product.product_id,
						operator_sign: null,
						amount_from: null,
						input_amount_from: null,
						amount_to: null,
						input_amount_to: null,
						currency_id: product.currency_id,
						input_currency_id: product.input_currency_id,
						fx_rate: product.fx_rate,
						fx_rate_ratio: product.fx_rate_ratio,
						discount_type: product.discount_type,
						discount_rate: product.discount_rate,
						input_discount_rate: product.input_discount_rate,
						incentive_type: product.incentive_type,
						incentive_rate: product.incentive_rate,
						input_incentive_rate: product.input_incentive_rate,
						_selected: product._selected,
					})
				});
				this.onCheckItem()
			}
		},
		addItem(product) {
			let newItem = {
				pro_group_id: product.pro_group_id,
				product_id: product.product_id,
				operator_sign: null,
				amount_from: null,
				input_amount_from: null,
				amount_to: null,
				input_amount_to: null,
				currency_id: product.currency_id,
				input_currency_id: product.input_currency_id,
				fx_rate: product.fx_rate,
				fx_rate_ratio: product.fx_rate_ratio,
				discount_type: product.discount_type,
				discount_rate: product.discount_rate,
				input_discount_rate: product.input_discount_rate,
				incentive_type: product.incentive_type,
				incentive_rate: product.incentive_rate,
				input_incentive_rate: product.input_incentive_rate,
				_selected: product._selected,
			}
			this.model.condition.push(newItem)
			this.onCheckItem()
		}
	},
}
</script>

<style scoped>
.form-control {
	height: 30px;
}
</style>
<style>
.filter .ant-select-selection--single {
	height: 29px;
}

.ivu-checkbox-small {
	margin: 0;
}
</style>